export class PROPERTIES {
  public static Allikas = '1f4846cd-bd08-4332-9fcf-c6a709b85e12';
  public static AllikaNumber = 'de3b83e1-7c07-4161-b635-f36026df4d91';
  public static Weight = '9a163034-10c9-4ee8-94e0-fc57a17f6428';
  public static OrderCost = 'ca62d7ff-18a0-4442-8d9f-5c488e19e6fe';
  public static GTIN = '0df3b76d-9fba-4486-8b77-da3eef92550f';
  public static ItemNameTemplate = 'f28df7dd-6a8b-4594-b0c9-1186d91ee4cb';
  public static DirectoOrderIntComment = '02abd24e-a096-4788-b55b-5514c2785701';
  public static VisibleInConfigurator = '63aef16a-6841-40ae-972f-d57c6f8a6ca2';
  public static ConfiguratorGroupName = '7e1a0e84-fb0a-4245-8681-b187daca676a';
  public static ImeListFilterSettings = '450df414-a98c-45d4-bcf1-b0e933ecdf2b';
  public static ItemListFilterSettings = '77fd224e-8d14-44ed-b339-2aad444eb94b';
  public static ItemGroupListFilterSettings = 'ee54f3dc-73aa-4fac-9eb2-c9c2894d0e64';
  public static ResourceListFilterSettings = 'a8b32480-46e4-48f4-bbff-29f8ecbd2464';
  public static ConfigurationListFilterSettings = 'efa11540-d585-4938-bdd2-8aaaeef4438b';
  public static Favourites = '858ec245-b31c-48f0-b437-28e829753992';
  public static DisplayColor = '7a971607-f41f-4928-a94e-5b94aeebedd4';
  public static SpecLinesEditColumns = '66de3c25-d903-4643-9fdc-1aa398e7a248';
  public static Note = '7e36b7e4-0bb3-4ec4-92e2-5d2c7b623d80';
  public static ReportedLotCode = 'fb974b6e-cfaf-48fd-a8de-2ae88777705f';
  public static ExternalCode = '66ecdeea-43d0-4fe0-a0ec-e550ec6200bf';
  public static ExternalName = '85c3c004-8da0-4c1b-9913-b4cc2347edf2';
  public static Status = 'c61042c7-307d-46eb-a86f-e66b7779d827';
  public static Blocked = '75912828-e29d-40c4-990d-c33ec37275c2';
}

